const initialState = {
    pending: false,
    weatherStations: [],
    page: 0,
    itemsCount: 0,
    pageCount: 0,
    error: null,
    filters: {active: 'ALL', itemsPerPage: 3, search: '', rimOnly: false},
    selected: {}
};

const weatherStationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_WEATHER_STATIONS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_WEATHER_STATIONS_SUCCESS':
            return {
                ...state,
                pending: false,
                weatherStations: action.stations,
                page: action.page,
                pageCount: action.pageCount,
                itemsCount: action.itemsCount
            };
        case 'GET_WEATHER_STATIONS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_WEATHER_STATION':
            return {
                ...state,
                selected: action.selected
            };
        case 'SET_WEATHER_STATIONS_FILTERS':
            return {
                ...state,
                filters: action.filters
            };
        case 'ADD_WEATHER_STATION_SUCCESS':
            return {
                ...state,
                pending: false
            };
        case 'ADD_WEATHER_STATION_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default weatherStationsReducer;
